import { defineMessages } from 'react-intl';

export default defineMessages({
  errorTitle: {
    id: 'usecore.error.title',
    defaultMessage: 'Ops! Algo não saiu como esperado.',
  },
  errorSubtitle: {
    id: 'usecore.error.subtitle',
    defaultMessage: 'Clique em recarregar para resolver rapidamente e continuar aproveitando tudo que a USECORE te oferece. Se recarregar a tela não resolver o problema, fale com o nosso suporte.',
  },
  reloadButton: {
    id: 'usecore.error.reloadButton',
    defaultMessage: 'Recarregar Página',
  },
  loadingTimeout: {
    id: 'usecore.loading.timeout',
    defaultMessage: 'Está demorando mais do que o previsto, aguarde....',
  },
  loadingConfig: {
    id: 'usecore.loading.config',
    defaultMessage: 'Carregando Pré Configurações....',
  },
  newPage: {
    id: 'usecore.breakPage.newPage',
    defaultMessage: 'Nova Página',
  },
  predictedValue: {
    id: 'usecore.qualifierCard.predictedValue',
    defaultMessage: 'Valor Predito',
  },
  obtainedValue: {
    id: 'usecore.qualifierCard.obtainedValue',
    defaultMessage: 'Valor Obtido',
  },
  deficiency: {
    id: 'usecore.qualifierCard.deficiency',
    defaultMessage: 'Deficiência',
  },
  cif: {
    id: 'usecore.qualifierCard.cif',
    defaultMessage: 'CIF',
  },
  cifFullTitle: {
    id: 'usecore.qualifierCard.cifFullTitle',
    defaultMessage: 'CIF - Classificação Internacional de Funcionalidade',
  },
  newPhoto: {
    id: 'usecore.cropper.newPhoto',
    defaultMessage: 'Nova Foto',
  },
  save: {
    id: 'usecore.cropper.save',
    defaultMessage: 'Salvar',
  },
  attention: {
    id: 'usecore.cropper.attention',
    defaultMessage: 'Atenção',
  },
  invalidImage: {
    id: 'usecore.cropper.invalidImage',
    defaultMessage: 'Escolha uma imagem válida.',
  },
  search: {
    id: 'usecore.searchButton.search',
    defaultMessage: 'Pesquisar',
  },
  modelField: {
    id: 'usecore.card.modelField',
    defaultMessage: 'Model',
  },
  personalField: {
    id: 'usecore.card.personalField',
    defaultMessage: 'Personal',
  },
  modelFieldDescription: {
    id: 'usecore.card.modelFieldDescription',
    defaultMessage: 'Campo padronizado na plataforma para possibilitar análise de dados, comparativo e benchmarking de resultados.',
  },
  personalFieldDescription: {
    id: 'usecore.card.personalFieldDescription',
    defaultMessage: 'Campo criado de forma personalizada pelo usuário e que não é um modelo disponibilizado pela plataforma.',
  },
  selectPlaceholder: {
    id: 'usecore.select.placeholder',
    defaultMessage: 'Selecione',
  },
  gaugeChartTitle: {
    id: 'usecore.gaugeChart.title',
    defaultMessage: 'Meus sintomas',
  },
  gaugeChartImproved: {
    id: 'usecore.gaugeChart.improved',
    defaultMessage: 'melhoraram',
  },
  gaugeChartWorsened: {
    id: 'usecore.gaugeChart.worsened',
    defaultMessage: 'pioraram',
  },
  gaugeChartPoints: {
    id: 'usecore.gaugeChart.points',
    defaultMessage: 'pontos',
  },
  gaugeChartUntilNow: {
    id: 'usecore.gaugeChart.untilNow',
    defaultMessage: 'até agora!',
  },
  closeModal: {
    id: 'usecore.modal.close',
    defaultMessage: 'Fechar Modal',
  },
  uploadImageTitle: {
    id: 'usecore.modal.uploadImage.title',
    defaultMessage: 'Upload - Imagem',
  },
  logoAlt: {
    id: 'usecore.imageUploader.logoAlt',
    defaultMessage: 'Logomarca',
  },
  editLogo: {
    id: 'usecore.imageUploader.editLogo',
    defaultMessage: 'Editar logomarca',
  },
  drawerApps: {
    id: 'usecore.drawer.apps',
    defaultMessage: 'Aplicativos',
  },
  drawerAccessManagement: {
    id: 'usecore.drawer.accessManagement',
    defaultMessage: 'Gestão de Acesso',
  },
  drawerUsers: {
    id: 'usecore.drawer.users',
    defaultMessage: 'Usuários',
  },
  drawerClients: {
    id: 'usecore.drawer.clients',
    defaultMessage: 'Clientes',
  },
  drawerMedicalRecords: {
    id: 'usecore.drawer.medicalRecords',
    defaultMessage: 'Prontuário',
  },
  drawerDocuments: {
    id: 'usecore.drawer.documents',
    defaultMessage: 'Documentos',
  },
  drawerBusinessManager: {
    id: 'usecore.drawer.businessManager',
    defaultMessage: 'Gerenciador de Negócios',
  },
  drawerBusiness: {
    id: 'usecore.drawer.business',
    defaultMessage: 'Negócios',
  },
  drawerWorkspaces: {
    id: 'usecore.drawer.workspaces',
    defaultMessage: 'Workspaces',
  },
  drawerPermissions: {
    id: 'usecore.drawer.permissions',
    defaultMessage: 'Permissões',
  },
  drawerBusinessPermission: {
    id: 'usecore.drawer.businessPermission',
    defaultMessage: 'Negócio',
  },
  drawerWorkspacesPermission: {
    id: 'usecore.drawer.workspacesPermission',
    defaultMessage: 'Workspaces',
  },
  drawerSettings: {
    id: 'usecore.drawer.settings',
    defaultMessage: 'Configurações',
  },
  drawerMedicalRecordsConfig: {
    id: 'usecore.drawer.medicalRecordsConfig',
    defaultMessage: 'Prontuário',
  },
  drawerAIAgentsConfig: {
    id: 'usecore.drawer.aiAgentsConfig',
    defaultMessage: 'Agentes de IA',
  },
  drawerIntegrations: {
    id: 'usecore.drawer.integrations',
    defaultMessage: 'Integrações',
  },
  drawerServices: {
    id: 'usecore.drawer.services',
    defaultMessage: 'Serviços',
  },
  drawerReports: {
    id: 'usecore.drawer.reports',
    defaultMessage: 'Relatórios',
  },
  drawerDashboard: {
    id: 'drawer.dashboard',
    defaultMessage: 'Dashboard'
  },
  drawerTemplates: {
    id: 'drawer.templates',
    defaultMessage: 'Templates'
  },
  drawerProfile: {
    id: 'usecore.drawer.profile',
    defaultMessage: 'Perfil',
  },
  drawerUser: {
    id: 'usecore.drawer.user',
    defaultMessage: 'Usuário',
  },
  drawerSwitchBusiness: {
    id: 'usecore.drawer.switchBusiness',
    defaultMessage: 'Trocar de {type}',
  },
  drawerManager: {
    id: 'usecore.drawer.manager',
    defaultMessage: 'Manager',
  },
  drawerLogout: {
    id: 'usecore.drawer.logout',
    defaultMessage: 'Logout',
  },
  drawerLogoutDescription: {
    id: 'usecore.drawer.logoutDescription',
    defaultMessage: 'Sair do Sistema',
  },
  drawerActive: {
    id: 'usecore.drawer.active',
    defaultMessage: 'Ativo',
  },
  toolbarBack: {
    id: 'usecore.toolbar.back',
    defaultMessage: 'Voltar',
  },
  toolbarBusiness: {
    id: 'usecore.toolbar.business',
    defaultMessage: 'Negócio',
  },
  toolbarWorkspace: {
    id: 'usecore.toolbar.workspace',
    defaultMessage: 'Workspace',
  },
  dashboardName: {
    id: 'usecore.dashboard.name',
    defaultMessage: 'Nome da dashboard',
  },
  dashboardNamePlaceholder: {
    id: 'usecore.dashboard.namePlaceholder',
    defaultMessage: 'Digite o nome da dashboard',
  },
  dashboardDescription: {
    id: 'usecore.dashboard.description',
    defaultMessage: 'Descrição',
  },
  dashboardDescriptionPlaceholder: {
    id: 'usecore.dashboard.descriptionPlaceholder',
    defaultMessage: 'Descrição...',
  },
  dashboardIndicators: {
    id: 'usecore.dashboard.indicators',
    defaultMessage: 'Indicadores',
  },
  dashboardAddIndicator: {
    id: 'usecore.dashboard.addIndicator',
    defaultMessage: 'Adicionar indicador',
  },
  dashboardNoIndicators: {
    id: 'usecore.dashboard.noIndicators',
    defaultMessage: 'Nenhum indicador adicionado',
  },
  dashboardSave: {
    id: 'usecore.dashboard.save',
    defaultMessage: 'Salvar',
  },
  dashboardNameRequired: {
    id: 'usecore.dashboard.nameRequired',
    defaultMessage: 'Preencha o nome da dashboard',
  },
  dashboardMenuEdit: {
    id: 'usecore.dashboard.menu.edit',
    defaultMessage: 'Editar',
  },
  dashboardMenuDelete: {
    id: 'usecore.dashboard.menu.delete',
    defaultMessage: 'Excluir',
  },
  dashboardAddVariable: {
    id: 'usecore.dashboard.addVariable',
    defaultMessage: 'Adicionar variável',
  },
  dashboardResultGraphType: {
    id: 'usecore.dashboard.resultGraphType',
    defaultMessage: 'Tipo de gráfico Resultado',
  },
  dashboardDeficiencyGraphType: {
    id: 'usecore.dashboard.deficiencyGraphType',
    defaultMessage: 'Tipo de gráfico Deficiência',
  },
  dashboardPerformance: {
    id: 'usecore.dashboard.performance',
    defaultMessage: 'Desempenho',
  },
  dashboardEvolution: {
    id: 'usecore.dashboard.evolution',
    defaultMessage: 'Evolução',
  },
  dashboardHistory: {
    id: 'usecore.dashboard.history',
    defaultMessage: 'Histórico',
  },
  dashboardDeficiencyPerformance: {
    id: 'usecore.dashboard.deficiencyPerformance',
    defaultMessage: 'Desempenho da Deficiência',
  },
  dashboardDeficiency: {
    id: 'usecore.dashboard.deficiency',
    defaultMessage: 'Deficiência',
  },
  dashboardDeficiencyHistory: {
    id: 'usecore.dashboard.deficiencyHistory',
    defaultMessage: 'Histórico da Deficiência',
  },
  dashboardCancel: {
    id: 'usecore.dashboard.cancel',
    defaultMessage: 'Cancelar',
  },
  dashboardSearchFieldPlaceholder: {
    id: 'usecore.dashboard.searchField.placeholder',
    defaultMessage: 'Busque o nome do campo',
  },
  noPermissionTitle: {
    id: 'usecore.noPermission.title',
    defaultMessage: 'Ausência de permissão',
  },
  noPermissionMessage: {
    id: 'usecore.noPermission.message',
    defaultMessage: 'Você não possui a permissão necessária para acessar esta página ou para executar esta ação.',
  },
  noPermissionContact: {
    id: 'usecore.noPermission.contact',
    defaultMessage: 'Caso julgue ser necessário ter acesso a elas, entre em contato com seu coordenador ou administrador.',
  },
  noPermissionClose: {
    id: 'usecore.noPermission.close',
    defaultMessage: 'Fechar',
  },
  plansChoosePlan: {
    id: 'usecore.plans.choosePlan',
    defaultMessage: 'Escolha seu plano',
  },
  plansStartPlan: {
    id: 'usecore.plans.startPlan',
    defaultMessage: 'Plano Start',
  },
  plansWorkspaces: {
    id: 'usecore.plans.workspaces',
    defaultMessage: 'Workspaces',
  },
  plansNumberOfWorkspaces: {
    id: 'usecore.plans.numberOfWorkspaces',
    defaultMessage: 'Nº de Workspaces:',
  },
  plansUsers: {
    id: 'usecore.plans.users',
    defaultMessage: 'Usuários',
  },
  plansNumberOfUsers: {
    id: 'usecore.plans.numberOfUsers',
    defaultMessage: 'Nº de Usuários:',
  },
  plansMoreThan20Users: {
    id: 'usecore.plans.moreThan20Users',
    defaultMessage: 'Quero mais de 20 usuários',
  },
  plansPurchaseSummary: {
    id: 'usecore.plans.purchaseSummary',
    defaultMessage: 'Resumo de Compra',
  },
  plansPlan: {
    id: 'usecore.plans.plan',
    defaultMessage: 'Plano:',
  },
  plansLoyalty: {
    id: 'usecore.plans.loyalty',
    defaultMessage: 'Fidelidade',
  },
  plansAnnual: {
    id: 'usecore.plans.annual',
    defaultMessage: 'Anual',
  },
  plansMonthly: {
    id: 'usecore.plans.monthly',
    defaultMessage: 'Mensal',
  },
  plansValuePerUser: {
    id: 'usecore.plans.valuePerUser',
    defaultMessage: 'Valor por Usuário',
  },
  plansTotalValue: {
    id: 'usecore.plans.totalValue',
    defaultMessage: 'Valor Total',
  },
  plansInstallment: {
    id: 'usecore.plans.installment',
    defaultMessage: 'Parcelamento',
  },
  plansMonthlyTotal: {
    id: 'usecore.plans.monthlyTotal',
    defaultMessage: 'Total Mensal',
  },
  plansConfirmPlan: {
    id: 'usecore.plans.confirmPlan',
    defaultMessage: 'Confirmar Plano',
  },
  plansHelp: {
    id: 'usecore.plans.help',
    defaultMessage: 'Ajuda',
  },
  plansHelpMessage: {
    id: 'usecore.plans.helpMessage',
    defaultMessage: 'Olá {name}, para melhor atendermos as suas necessidades, entre em contato com nosso time de consultores especializados clicando no link abaixo.',
  },
  plansHelpMessage2: {
    id: 'usecore.plans.helpMessage2',
    defaultMessage: 'Informe ao consultor que deseja mais de 20 usuários. Ele irá entender suas necessidades e te ajudar da melhor maneira possível. Aguardamos seu contato pelo chat.',
  },
  plansOpenChat: {
    id: 'usecore.plans.openChat',
    defaultMessage: 'CLIQUE AQUI PARA ABRIR O CHAT',
  },
  boletoBillingData: {
    id: 'usecore.boleto.billingData',
    defaultMessage: 'Dados de Cobrança',
  },
  boletoName: {
    id: 'usecore.boleto.name',
    defaultMessage: 'Nome',
  },
  boletoCnpj: {
    id: 'usecore.boleto.cnpj',
    defaultMessage: 'CNPJ',
  },
  boletoCpf: {
    id: 'usecore.boleto.cpf',
    defaultMessage: 'CPF',
  },
  boletoEmail: {
    id: 'usecore.boleto.email',
    defaultMessage: 'E-mail',
  },
  boletoAddress: {
    id: 'usecore.boleto.address',
    defaultMessage: 'Endereço',
  },
  cardCreditCardData: {
    id: 'usecore.card.creditCardData',
    defaultMessage: 'Dados utilizados no Cartão de Crédito',
  },
  cardAccepted: {
    id: 'usecore.card.accepted',
    defaultMessage: 'Aceitamos:',
  },
  cardHolder: {
    id: 'usecore.card.holder',
    defaultMessage: 'Titular',
  },
  cardNameOnCard: {
    id: 'usecore.card.nameOnCard',
    defaultMessage: 'Nome no cartão',
  },
  cardNameOnCardPlaceholder: {
    id: 'usecore.card.nameOnCardPlaceholder',
    defaultMessage: 'Nome no cartão',
  },
  cardNumber: {
    id: 'usecore.card.number',
    defaultMessage: 'Número do Cartão',
  },
  cardNumberPlaceholder: {
    id: 'usecore.card.numberPlaceholder',
    defaultMessage: 'Número do cartão',
  },
  cardExpirationDate: {
    id: 'usecore.card.expirationDate',
    defaultMessage: 'Válido até',
  },
  cardExpirationDatePlaceholder: {
    id: 'usecore.card.expirationDatePlaceholder',
    defaultMessage: '__/____',
  },
  cardCvc: {
    id: 'usecore.card.cvc',
    defaultMessage: 'CVC',
  },
  cardCvcPlaceholder: {
    id: 'usecore.card.cvcPlaceholder',
    defaultMessage: 'CVC',
  },
  cardInvalidCard: {
    id: 'usecore.card.invalidCard',
    defaultMessage: 'Cartão Inválido',
  },
  cardInvalidDate: {
    id: 'usecore.card.invalidDate',
    defaultMessage: 'Data inválida',
  },
  cardInvalidCvc: {
    id: 'usecore.card.invalidCvc',
    defaultMessage: 'CVC Inválido',
  },
  cardChangeCreditCard: {
    id: 'usecore.card.changeCreditCard',
    defaultMessage: 'Trocar o cartão de crédito',
  },
  paymentMethodTitle: {
    id: 'usecore.paymentMethod.title',
    defaultMessage: 'Método de Pagamento',
  },
  paymentMethodCreditCard: {
    id: 'usecore.paymentMethod.creditCard',
    defaultMessage: 'Cartão de crédito',
  },
  paymentMethodBoleto: {
    id: 'usecore.paymentMethod.boleto',
    defaultMessage: 'Boleto',
  },
  scoresVerificationRequired: {
    id: 'usecore.scores.verificationRequired',
    defaultMessage: 'Verificação de Cálculos Obrigatória',
  },
  scoresEditWarning: {
    id: 'usecore.scores.editWarning',
    defaultMessage: 'Ao editar o posicionamento de campos no seu formulário, é necessário revisar e atualizar as referências de campos que compõe as formulas nos campos de cálculos.',
  },
  scoresAffectedFields: {
    id: 'usecore.scores.affectedFields',
    defaultMessage: 'Os campos de Cálculo afetados e que necessitam ser revisados, e atualizados, estão marcados de vermelho.',
  },
  scoresReviewRequired: {
    id: 'usecore.scores.reviewRequired',
    defaultMessage: 'Por favor, revise e atualize as formulas para conseguir salvar.',
  },
  scoresClose: {
    id: 'usecore.scores.close',
    defaultMessage: 'Fechar',
  },
  categoryUndefined: {
    id: 'usecore.category.undefined',
    defaultMessage: 'Categoria Indefinida',
  },
  tableNoData: {
    id: 'usecore.table.noData',
    defaultMessage: 'Nenhum dado encontrado...',
  },
  tableRowsPerPage: {
    id: 'usecore.table.rowsPerPage',
    defaultMessage: 'Linhas Por Páginas',
  },
  timelineLoadMore: {
    id: 'usecore.timeline.loadMore',
    defaultMessage: 'Carregar Mais',
  },
  timelineNoAttendances: {
    id: 'usecore.timeline.noAttendances',
    defaultMessage: 'Não existem atendimentos liberados para este paciente',
  },
  attendanceBy: {
    id: 'usecore.attendance.by',
    defaultMessage: 'Por:',
  },
  attendanceSharedWithYou: {
    id: 'usecore.attendance.sharedWithYou',
    defaultMessage: 'e compartilhado com você',
  },
  attendancePublicTitle: {
    id: 'usecore.attendance.publicTitle',
    defaultMessage: 'Todos podem visualizar este atendimento',
  },
  attendancePrivateTitle: {
    id: 'usecore.attendance.privateTitle',
    defaultMessage: 'Somente você pode visualizar este atendimento',
  },
  attendanceSharedTitle: {
    id: 'usecore.attendance.sharedTitle',
    defaultMessage: 'Todos os membros do grupo de acesso podem visualizar este atendimento',
  },
  attendancePrescriptions: {
    id: 'usecore.attendance.prescriptions',
    defaultMessage: 'Prescrições',
  },
  attendanceCertificates: {
    id: 'usecore.attendance.certificates',
    defaultMessage: 'Atestados',
  },
  attendanceReferrals: {
    id: 'usecore.attendance.referrals',
    defaultMessage: 'Encaminhamentos Médicos',
  },
  attendanceReports: {
    id: 'usecore.attendance.reports',
    defaultMessage: 'Relatórios',
  },
  attendanceRequests: {
    id: 'usecore.attendance.requests',
    defaultMessage: 'Solicitações',
  },
  attendanceMedia: {
    id: 'usecore.attendance.media',
    defaultMessage: 'Mídia',
  },
  attendanceAttachments: {
    id: 'usecore.attendance.attachments',
    defaultMessage: 'Anexos',
  },
  attendanceExams: {
    id: 'usecore.attendance.exams',
    defaultMessage: 'Exames',
  },
  infoAddedAt: {
    id: 'usecore.info.addedAt',
    defaultMessage: 'Informação adicionada em {date} às {time}',
  },
  qualifierDeficiency: {
    id: 'usecore.qualifier.deficiency',
    defaultMessage: 'Qualificador da deficiência',
  },
  qualifier: {
    id: 'usecore.qualifier.title',
    defaultMessage: 'Qualificador',
  },
  datetimeAt: {
    id: 'usecore.datetime.at',
    defaultMessage: 'às',
  },
  graphicColumns: {
    id: 'usecore.graphic.columns',
    defaultMessage: 'Colunas',
  },
  graphicAttendance: {
    id: 'usecore.graphic.attendance',
    defaultMessage: 'Atent. {date}',
  },
  graphicNoData: {
    id: 'usecore.graphic.noData',
    defaultMessage: 'Não é possível exibir o gráfico. O campo não está configurado.',
  },
  imageSelectCategory: {
    id: 'usecore.image.selectCategory',
    defaultMessage: 'Selecione a categoria da imagem',
  },
  imageDescription: {
    id: 'usecore.image.description',
    defaultMessage: 'Descrição',
  },
  imageAlt: {
    id: 'usecore.image.alt',
    defaultMessage: 'Imagem {index}',
  },
  markTotalObjectives: {
    id: 'usecore.mark.totalObjectives',
    defaultMessage: 'Total de objetivos',
  },
  markAverageObjectives: {
    id: 'usecore.mark.averageObjectives',
    defaultMessage: 'Média dos objetivos',
  },
  markProgress: {
    id: 'usecore.mark.progress',
    defaultMessage: 'Progresso %',
  },
  periodFrom: {
    id: 'usecore.period.from',
    defaultMessage: 'De',
  },
  periodTo: {
    id: 'usecore.period.to',
    defaultMessage: 'a',
  },
  periodYears: {
    id: 'usecore.period.years',
    defaultMessage: '{count, plural, one {ano} other {anos}}',
  },
  periodMonths: {
    id: 'usecore.period.months',
    defaultMessage: '{count, plural, one {mês} other {meses}}',
  },
  periodDays: {
    id: 'usecore.period.days',
    defaultMessage: '{count, plural, one {dia} other {dias}}',
  },
  periodAnd: {
    id: 'usecore.period.and',
    defaultMessage: 'e',
  },
  periodNoData: {
    id: 'usecore.period.noData',
    defaultMessage: 'Sem dados',
  },
  periodDatetimeFrom: {
    id: 'usecore.periodDatetime.from',
    defaultMessage: 'De',
  },
  periodDatetimeAt: {
    id: 'usecore.periodDatetime.at',
    defaultMessage: 'às',
  },
  periodDatetimeUntil: {
    id: 'usecore.periodDatetime.until',
    defaultMessage: 'até',
  },
  periodDatetimeHours: {
    id: 'usecore.periodDatetime.hours',
    defaultMessage: '{count, plural, one {hora} other {horas}}',
  },
  periodDatetimeMinutes: {
    id: 'usecore.periodDatetime.minutes',
    defaultMessage: '{count, plural, one {minuto} other {minutos}}',
  },
  periodDatetimeSeconds: {
    id: 'usecore.periodDatetime.seconds',
    defaultMessage: '{count, plural, one {segundo} other {segundos}}',
  },
  periodTimeFrom: {
    id: 'usecore.periodTime.from',
    defaultMessage: 'De',
  },
  periodTimeAt: {
    id: 'usecore.periodTime.at',
    defaultMessage: 'às',
  },
  transferSource: {
    id: 'usecore.transfer.source',
    defaultMessage: 'Origem',
  },
  transferDestination: {
    id: 'usecore.transfer.destination',
    defaultMessage: 'Destino',
  },
  namePatient: {
    id: 'usecore.namePatient',
    defaultMessage: 'Nome do Paciente',
  },
  rgPatient: {
    id: 'usecore.rgPatient',
    defaultMessage: 'RG do Paciente',
  },
  cpfPatient: {
    id: 'usecore.cpfPatient',
    defaultMessage: 'CPF do Paciente',
  },
  phonePatient: {
    id: 'usecore.phonePatient',
    defaultMessage: 'Telefone do Paciente',
  },
  cellphonePatient: {
    id: 'usecore.cellphonePatient',
    defaultMessage: 'Celular do Paciente',
  },
  emailPatient: {
    id: 'usecore.emailPatient',
    defaultMessage: 'Email do Paciente',
  },
  birthdatePatient: {
    id: 'usecore.birthdatePatient',
    defaultMessage: 'Aniversário do Paciente',
  },
  nameProfessional: {
    id: 'usecore.nameProfessional',
    defaultMessage: 'Nome do Profissional',
  },
  cpfProfessional: {
    id: 'usecore.cpfProfessional',
    defaultMessage: 'CPF do Profissional',
  },
  professionProfessional: {
    id: 'usecore.professionProfessional',
    defaultMessage: 'Profissão do Profissional',
  },
  councilProfessional: {
    id: 'usecore.councilProfessional',
    defaultMessage: 'Conselho do Profissional',
  },
  registerProfessional: {
    id: 'usecore.registerProfessional',
    defaultMessage: 'Registro do Profissional',
  },
  councilAreaProfessional: {
    id: 'usecore.councilAreaProfessional',
    defaultMessage: 'UF/Região do Conselho Profissional',
  },
  attendanceDate: {
    id: 'usecore.attendanceDate',
    defaultMessage: 'Data de Atendimento',
  },
  writeSomething: {
    id: 'usecore.writeSomething',
    defaultMessage: 'Escreva alguma coisa...',
  },
  deficiencyQualifier: {
    id: 'usecore.deficiencyQualifier',
    defaultMessage: 'Qualificador da deficiência',
  },
  resultQualifier: {
    id: 'usecore.resultQualifier',
    defaultMessage: 'Qualificador do resultado',
  },
  comparedTo: {
    id: 'usecore.comparedTo',
    defaultMessage: 'Comparado a',
  },
  now: {
    id: 'usecore.now',
    defaultMessage: 'Agora',
  },
  start: {
    id: 'usecore.start',
    defaultMessage: 'Início',
  },
  drawerLanguageConfig: {
    id: 'usecore.drawer.languageConfig',
    defaultMessage: 'Idioma',
  },
  selectAnatomicalArea: {
    id: 'usecore.joinMobility.selectAnatomicalArea',
    defaultMessage: 'Selecionar Área Anatômica',
  },
  movements: {
    id: 'usecore.joinMobility.movements',
    defaultMessage: 'movimentos',
  },
  bilateral: {
    id: 'usecore.joinMobility.bilateral',
    defaultMessage: 'Bilateral',
  },
  noLaterality: {
    id: 'usecore.joinMobility.noLaterality',
    defaultMessage: 'Sem Lateralidade',
  },
  asymmetry: {
    id: 'usecore.joinMobility.asymmetry',
    defaultMessage: 'Assimetria',
  },
  rightSide: {
    id: 'usecore.joinMobility.rightSide',
    defaultMessage: 'Lado Direito',
  },
  leftSide: {
    id: 'usecore.joinMobility.leftSide',
    defaultMessage: 'Lado Esquerdo',
  },
  unilateralAssessment: {
    id: 'usecore.joinMobility.unilateralAssessment',
    defaultMessage: 'Avaliação Unilateral',
  },
  asymmetryDetected: {
    id: 'usecore.joinMobility.asymmetryDetected',
    defaultMessage: 'Assimetria Detectada',
  },
  type: {
    id: 'usecore.joinMobility.type',
    defaultMessage: 'Tipo',
  },
  maxValue: {
    id: 'usecore.joinMobility.maxValue',
    defaultMessage: 'Max',
  },
  noValueRecorded: {
    id: 'usecore.joinMobility.noValueRecorded',
    defaultMessage: 'Nenhuma valor registrado',
  },
  measuredValue: {
    id: 'usecore.joinMobility.measuredValue',
    defaultMessage: 'Valor medido',
  },
  maxNormal: {
    id: 'usecore.joinMobility.maxNormal',
    defaultMessage: 'Max. Normal',
  },
  nprsPainScale: {
    id: 'usecore.joinMobility.nprsPainScale',
    defaultMessage: 'NPRs - Escala de Dor (0-10)',
  },
  painType: {
    id: 'usecore.joinMobility.painType',
    defaultMessage: 'Tipo de dor',
  },
  painMoment: {
    id: 'usecore.joinMobility.painMoment',
    defaultMessage: 'Momento da dor',
  },
  endFeel: {
    id: 'usecore.joinMobility.endFeel',
    defaultMessage: 'End-feel',
  },
  observedCompensations: {
    id: 'usecore.joinMobility.observedCompensations',
    defaultMessage: 'Compensações observadas',
  },
  clinicalObservations: {
    id: 'usecore.joinMobility.clinicalObservations',
    defaultMessage: 'Observações clínicas',
  },
  select: {
    id: 'usecore.joinMobility.select',
    defaultMessage: 'Selecionar',
  },
  compensationPlaceholder: {
    id: 'usecore.joinMobility.compensationPlaceholder',
    defaultMessage: 'Ex: Elevação de escápula, rotação de tronco...',
  },
  observationsPlaceholder: {
    id: 'usecore.joinMobility.observationsPlaceholder',
    defaultMessage: 'Ex: Dor irradia para braço, rigidez matinal...',
  },
  emptyEndFeelAlert: {
    id: 'usecore.joinMobility.emptyEndFeelAlert',
    defaultMessage: '⚠️ ALERTA: End-feel vazio indica possível lesão grave',
  },
  charactersCount: {
    id: 'usecore.joinMobility.charactersCount',
    defaultMessage: '{current}/{max} caracteres',
  },
  active: {
    id: 'usecore.jointMobility.active',
    defaultMessage: 'Ativo',
  },
  passive: {
    id: 'usecore.jointMobility.passive',
    defaultMessage: 'Passivo',
  },
  activeAssisted: {
    id: 'usecore.jointMobility.activeAssisted',
    defaultMessage: 'Ativo-assistido',
  },
  activeResisted: {
    id: 'usecore.jointMobility.activeResisted',
    defaultMessage: 'Ativo-resistido',
  },
  pressure: {
    id: 'usecore.jointMobility.pressure',
    defaultMessage: 'Pressão',
  },
  burning: {
    id: 'usecore.jointMobility.burning',
    defaultMessage: 'Queimação',
  },
  punch: {
    id: 'usecore.jointMobility.punch',
    defaultMessage: 'Pontada',
  },
  throbbing: {
    id: 'usecore.jointMobility.throbbing',
    defaultMessage: 'Latejante',
  },
  rigidity: {
    id: 'usecore.jointMobility.rigidity',
    defaultMessage: 'Rigidez',
  },
  colic: {
    id: 'usecore.jointMobility.colic',
    defaultMessage: 'Cólica',
  },
  shock: {
    id: 'usecore.jointMobility.shock',
    defaultMessage: 'Choque',
  },
  middle: {
    id: 'usecore.jointMobility.middle',
    defaultMessage: 'Meio',
  },
  end: {
    id: 'usecore.jointMobility.end',
    defaultMessage: 'Final',
  },
  during: {
    id: 'usecore.jointMobility.during',
    defaultMessage: 'Durante todo movimento',
  },
  hard: {
    id: 'usecore.jointMobility.hard',
    defaultMessage: 'Duro',
  },
  soft: {
    id: 'usecore.jointMobility.soft',
    defaultMessage: 'Macio',
  },
  elastic: {
    id: 'usecore.jointMobility.elastic',
    defaultMessage: 'Elástico',
  },
  spastic: {
    id: 'usecore.jointMobility.spastic',
    defaultMessage: 'Espástico',
  },
  empty: {
    id: 'usecore.jointMobility.empty',
    defaultMessage: 'Vazio',
  },
  undefined: {
    id: 'usecore.jointMobility.undefined',
    defaultMessage: 'Indefinido',
  },
  distalUpperLimbs: {
    id: 'usecore.jointMobility.distalUpperLimbs',
    defaultMessage: 'Extremidade Distal MMSS',
  },
  distalLowerLimbs: {
    id: 'usecore.jointMobility.distalLowerLimbs',
    defaultMessage: 'Extremidade Distal MMII',
  },
  radioulnar: {
    id: 'usecore.jointMobility.radioulnar',
    defaultMessage: 'Radioulnar',
  },
  wrist: {
    id: 'usecore.jointMobility.wrist',
    defaultMessage: 'Punho',
  },
  carpometacarpal: {
    id: 'usecore.jointMobility.carpometacarpal',
    defaultMessage: 'Carpometacárpica do polegar',
  },
  metacarpophalangeal: {
    id: 'usecore.jointMobility.metacarpophalangeal',
    defaultMessage: 'Metacarpofalangianas',
  },
  proximalInterphalangeal: {
    id: 'usecore.jointMobility.proximalInterphalangeal',
    defaultMessage: 'Interfalângicas Proximais',
  },
  distalInterphalangeal: {
    id: 'usecore.jointMobility.distalInterphalangeal',
    defaultMessage: 'Interfalângicas Distais',
  },
  metatarsophalangeal: {
    id: 'usecore.jointMobility.metatarsophalangeal',
    defaultMessage: 'Metatarsofalangianas',
  },
  interphalangeal: {
    id: 'usecore.jointMobility.interphalangeal',
    defaultMessage: 'Interfalângicas',
  },
  atm: {
    id: 'usecore.jointMobility.atm',
    defaultMessage: 'ATM',
  },
  internalRotation: {
    id: 'usecore.jointMobility.internalRotation',
    defaultMessage: 'Rotação interna',
  },
  externalRotation: {
    id: 'usecore.jointMobility.externalRotation',
    defaultMessage: 'Rotação externa',
  },
  adductionUlnarDeviation: {
    id: 'usecore.jointMobility.adductionUlnarDeviation',
    defaultMessage: 'Adução (desvio ulnar)',
  },
  abductionRadialDeviation: {
    id: 'usecore.jointMobility.abductionRadialDeviation',
    defaultMessage: 'Abdução (desvio radial)',
  },
  dorsalFlexion: {
    id: 'usecore.jointMobility.dorsalFlexion',
    defaultMessage: 'Flexão dorsal',
  },
  plantarFlexion: {
    id: 'usecore.jointMobility.plantarFlexion',
    defaultMessage: 'Flexão plantar',
  },
  mouthOpening: {
    id: 'usecore.jointMobility.mouthOpening',
    defaultMessage: 'Abertura da boca',
  },
  thumbExtension: {
    id: 'usecore.jointMobility.thumbExtension',
    defaultMessage: 'Extensão do 1º dedo do polegar',
  },
  thumbInternalExtension: {
    id: 'usecore.jointMobility.thumbInternalExtension',
    defaultMessage: 'Extensão int. do polegar',
  },
  fingerInternalExtension: {
    id: 'usecore.jointMobility.fingerInternalExtension',
    defaultMessage: 'Extensão int. 2 ao 5 dedo',
  },
  halluxFlexion: {
    id: 'usecore.jointMobility.halluxFlexion',
    defaultMessage: 'Flexão do hálux',
  },
  halluxExtension: {
    id: 'usecore.jointMobility.halluxExtension',
    defaultMessage: 'Extensão do hálux',
  },
  fingerFlexion25: {
    id: 'usecore.jointMobility.fingerFlexion25',
    defaultMessage: 'Flexão do 2º ao 5º dedo',
  },
  fingerExtension25: {
    id: 'usecore.jointMobility.fingerExtension25',
    defaultMessage: 'Extensão do 2º ao 5º dedo',
  },
  halluxFlexionI: {
    id: 'usecore.jointMobility.halluxFlexionI',
    defaultMessage: 'Flexão (I) do hálux',
  },
  proximalInterphalangeal25: {
    id: 'usecore.jointMobility.proximalInterphalangeal25',
    defaultMessage: 'Interfal. proximal (2º ao 5º)',
  },
  distalInterphalangeal25: {
    id: 'usecore.jointMobility.distalInterphalangeal25',
    defaultMessage: 'Interfal. distal (2º ao 5º)',
  },
  manual: {
    id: 'usecore.muscleStrength.manual',
    defaultMessage: 'Manual',
  },
  assisted: {
    id: 'usecore.muscleStrength.assisted',
    defaultMessage: 'Assistido',
  },
  resisted: {
    id: 'usecore.muscleStrength.resisted',
    defaultMessage: 'Resistido',
  },
  muscleStrength: {
    id: 'usecore.muscleStrength.muscleStrength',
    defaultMessage: 'Força Muscular',
  },
  professionalAssessment: {
    id: 'usecore.joinMobility.professionalAssessment',
    defaultMessage: 'Avaliação profissional de amplitude de movimento com identificação de assimetrias e geração de relatório'
  },
  assessment: {
    id: 'usecore.joinMobility.assessment',
    defaultMessage: 'Avaliação'
  },
  report: {
    id: 'usecore.joinMobility.report',
    defaultMessage: 'Relatório'
  },
  dynamometry: {
    id: 'usecore.muscleStrength.dynamometry',
    defaultMessage: 'Dinamometria'
  },
  addIndicatorFromForm: {
    id: 'usecore.dashboard.addIndicatorFromForm',
    defaultMessage: 'Adicionar a partir de formulário',
  },
  assistantChatTitle: {
    id: 'usecore.assistantChat.title',
    defaultMessage: 'Assistente IA',
  },
  assistantChatHeroTitle: {
    id: 'usecore.assistantChat.heroTitle',
    defaultMessage: 'Acesse informações essenciais rapidamente',
  },
  assistantChatInputPlaceholder: {
    id: 'usecore.assistantChat.inputPlaceholder',
    defaultMessage: 'Perguntar à IA',
  },
  assistantChatSuggestion: {
    id: 'usecore.assistantChat.suggestion',
    defaultMessage: 'Sugestão',
  },
  assistantChatThinking: {
    id: 'usecore.assistantChat.thinking',
    defaultMessage: 'Pensando',
  },
  assistantChatRemoveFile: {
    id: 'usecore.assistantChat.removeFile',
    defaultMessage: 'Remover arquivo',
  },
  assistantChatAddContext: {
    id: 'usecore.assistantChat.addContext',
    defaultMessage: 'Adicionar contexto',
  },
  assistantChatSend: {
    id: 'usecore.assistantChat.send',
    defaultMessage: 'Enviar',
  },
});
